module.exports = __webpack_public_path__ + "img/v2-plots-folder.1c40ee83.png";